import { formatAmountLogDate } from "@/utils/excelExport";

export const EXPORT_TYPE_ORDERS = "orders";
export const EXPORT_TYPE_USERS = "users";
export const EXPORT_TYPE_RECHARGE = "recharge";
export const EXPORT_TYPE_CONSUMPTION = "consumption";
export const EXPORT_TYPE_STATISTICS = "statistics";

export const EXPORT_TYPES = [
  EXPORT_TYPE_ORDERS,
  EXPORT_TYPE_USERS,
  EXPORT_TYPE_RECHARGE,
  EXPORT_TYPE_CONSUMPTION,
  EXPORT_TYPE_STATISTICS,
];

function amountLogTypeLabel(type, t) {
  if (type == 1) return t("user.detail.amountlog.charge");
  if (type == 2) return t("user.detail.amountlog.consumption");
  if (type == 3) return t("user.detail.amountlog.onlinepayment");
  return type;
}

function amountLogPaywayLabel(payway, t) {
  if (payway == 0) return t("user.detail.amountlog.background");
  if (payway == 2) return t("user.detail.amountlog.alipay");
  if (payway == 3) return t("user.detail.amountlog.wechatpay");
  return payway;
}

function amountLogStatusLabel(status, t) {
  if (status == 0) return t("user.detail.amountlog.notnormal");
  return t("user.detail.amountlog.normal");
}

function userStatusLabel(status, t) {
  if (status == 1) return t("admin.lists.normal");
  if (status == 0) return t("admin.lists.disable");
  return status;
}

export const orderColumns = [
  { key: "sn", labelKey: "orders.table.ordersn", default: true, get: (row) => row.sn },
  { key: "ED_id", labelKey: "orders.table.ED_id", default: true, get: (row) => row.ED_id },
  { key: "ED_name", labelKey: "orders.table.ED_name", default: true, get: (row) => row.ED_name },
  { key: "total", labelKey: "orders.table.total", default: true, get: (row) => row.total },
  { key: "value", labelKey: "orders.table.value", default: true, get: (row) => row.goodstotal },
  {
    key: "goodsname",
    labelKey: "orders.table.goodsname",
    default: true,
    get: (row) => row.goodsname || row.title || "",
  },
  { key: "createtime", labelKey: "orders.table.createtime", default: true, get: (row) => row.addtime },
  { key: "paytime", labelKey: "orders.table.paytime", default: true, get: (row) => row.paytime },
  { key: "payway", labelKey: "orders.table.payway", default: true, get: (row) => row.payway },
  { key: "status", labelKey: "orders.table.status", default: true, get: (row) => row.status },
  { key: "delete", labelKey: "orders.table.delete", default: true, get: (row) => row.isdel },
  { key: "user", labelKey: "orders.table.user", default: true, get: (row) => row.username },
  { key: "phone", labelKey: "orders.table.phone", default: true, get: (row) => row.phone },
];

export const userColumns = [
  { key: "id", labelKey: "admin.lists.userid", default: true, get: (row) => row.id },
  { key: "username", labelKey: "admin.lists.username", default: true, get: (row) => row.username },
  { key: "phone", labelKey: "admin.lists.phone", default: true, get: (row) => row.phone },
  { key: "source", labelKey: "user.list.source", default: true, get: (row) => row.source },
  { key: "bindshop", labelKey: "user.list.bindshop", default: true, get: (row) => row.bindshop },
  { key: "cardno", labelKey: "user.list.membercard", default: true, get: (row) => row.cardno },
  { key: "hex", labelKey: "user.list.membercardhex", default: true, get: (row) => row.hex },
  { key: "amount", labelKey: "user.list.amount", default: true, get: (row) => row.amount },
  {
    key: "status",
    labelKey: "admin.lists.status",
    default: true,
    get: (row, t) => userStatusLabel(row.status, t),
  },
];

export const amountLogColumns = [
  {
    key: "uid",
    labelKey: "admin.lists.userid",
    default: true,
    get: (row) => row._uid || row.uid || "",
  },
  {
    key: "username",
    labelKey: "admin.lists.username",
    default: true,
    get: (row) => row._username || row.username || "",
  },
  {
    key: "type",
    labelKey: "user.detail.amountlog.type",
    default: true,
    get: (row, t) => amountLogTypeLabel(row.type, t),
  },
  { key: "sn", labelKey: "user.detail.amountlog.sn", default: true, get: (row) => row.sn },
  { key: "price", labelKey: "user.detail.price", default: true, get: (row) => row.price },
  {
    key: "payway",
    labelKey: "user.detail.amountlog.payway",
    default: true,
    get: (row, t) => amountLogPaywayLabel(row.payway, t),
  },
  {
    key: "order",
    labelKey: "user.detail.amountlog.orders",
    default: true,
    get: (row) => row.order || "",
  },
  { key: "note", labelKey: "user.detail.amountlog.notes", default: true, get: (row) => row.note },
  {
    key: "status",
    labelKey: "user.detail.amountlog.status",
    default: true,
    get: (row, t) => amountLogStatusLabel(row.status, t),
  },
  {
    key: "date",
    labelKey: "user.detail.amountlog.date",
    default: true,
    get: (row) => formatAmountLogDate(row.sn),
  },
];

export const statisticsSummaryColumns = [
  {
    key: "metric",
    labelKey: "export.statistics.metric",
    default: true,
    get: (row, t) => t(row.metricKey),
  },
  {
    key: "count",
    labelKey: "statistics.sales.count",
    default: true,
    get: (row) => row.count,
  },
  {
    key: "amount",
    labelKey: "statistics.sales.amount",
    default: true,
    get: (row) => row.amount,
  },
  {
    key: "volume",
    labelKey: "statistics.sales.total",
    default: true,
    get: (row) => row.volume,
  },
];

export const statisticsByPaymentColumns = [
  {
    key: "payway",
    labelKey: "device.orders.paytype",
    default: true,
    get: (row) => row.paywayLabel,
  },
  {
    key: "total_count",
    labelKey: "statistics.sales.total_orders",
    default: true,
    get: (row) => row.total_count,
  },
  {
    key: "paid_count",
    labelKey: "statistics.sales.paid",
    default: true,
    get: (row) => row.paid_count,
  },
  {
    key: "unpaid_count",
    labelKey: "statistics.sales.unpaid",
    default: true,
    get: (row) => row.unpaid_count,
  },
  {
    key: "refund_count",
    labelKey: "statistics.sales.refund",
    default: true,
    get: (row) => row.refund_count,
  },
  {
    key: "paid_amount",
    labelKey: "statistics.sales.amount",
    default: true,
    get: (row) => row.paid_amount,
  },
];

export const statisticsByStatusColumns = [
  {
    key: "status",
    labelKey: "device.orders.orderstatus",
    default: true,
    get: (row) => row.statusLabel,
  },
  {
    key: "count",
    labelKey: "statistics.sales.count",
    default: true,
    get: (row) => row.count,
  },
  {
    key: "amount",
    labelKey: "statistics.sales.amount",
    default: true,
    get: (row) => row.amount,
  },
  {
    key: "total",
    labelKey: "statistics.sales.total",
    default: true,
    get: (row) => row.total,
  },
];

export const statisticsTrendColumns = [
  {
    key: "date",
    labelKey: "statistics.sales.date",
    default: true,
    get: (row) => row.date || row.month || "",
  },
  {
    key: "total_count",
    labelKey: "statistics.sales.total_orders",
    default: true,
    get: (row) => row.total_count,
  },
  {
    key: "paid_count",
    labelKey: "statistics.sales.paid",
    default: true,
    get: (row) => row.paid_count,
  },
  {
    key: "unpaid_count",
    labelKey: "statistics.sales.unpaid",
    default: true,
    get: (row) => row.unpaid_count,
  },
  {
    key: "refund_count",
    labelKey: "statistics.sales.refund",
    default: true,
    get: (row) => row.refund_count,
  },
  {
    key: "paid_amount",
    labelKey: "statistics.sales.amount",
    default: true,
    get: (row) => row.paid_amount,
  },
];

/** Flat columns for statistics column picker (prefixed keys). */
export const statisticsPickerColumns = [
  ...statisticsSummaryColumns.map((c) => ({
    ...c,
    key: `summary.${c.key}`,
    sheet: "summary",
    rawKey: c.key,
  })),
  ...statisticsByPaymentColumns.map((c) => ({
    ...c,
    key: `payment.${c.key}`,
    sheet: "payment",
    rawKey: c.key,
  })),
  ...statisticsByStatusColumns.map((c) => ({
    ...c,
    key: `status.${c.key}`,
    sheet: "status",
    rawKey: c.key,
  })),
  ...statisticsTrendColumns.map((c) => ({
    ...c,
    key: `trend.${c.key}`,
    sheet: "trend",
    rawKey: c.key,
  })),
];

export function getColumnsForType(type) {
  switch (type) {
    case EXPORT_TYPE_ORDERS:
      return orderColumns;
    case EXPORT_TYPE_USERS:
      return userColumns;
    case EXPORT_TYPE_RECHARGE:
    case EXPORT_TYPE_CONSUMPTION:
      return amountLogColumns;
    case EXPORT_TYPE_STATISTICS:
      return statisticsPickerColumns;
    default:
      return [];
  }
}

export function filterColumnsByKeys(columns, selectedKeys) {
  const keySet = new Set(selectedKeys || []);
  return (columns || []).filter((col) => keySet.has(col.key));
}

export function defaultSelectedKeys(columns) {
  return (columns || []).filter((c) => c.default !== false).map((c) => c.key);
}
